import Note from "./note";
import Notes from "./notes";
import notesReducer, { initialState, sortTypes} from "./notesSlice";

export {Note, notesReducer, initialState, sortTypes};
export default Notes;